module.exports = __webpack_public_path__ + "static/media/icon-zalo.aba847ae.svg";